import { useEffect, useState } from "react";
import api from "../../lib/api";
import { ArrowRightLeft, DollarSign } from "lucide-react";

const CURRENCIES = ["USD", "EUR", "GBP", "INR", "AED", "JPY", "CNY", "AUD", "CAD", "SGD", "CHF", "HKD", "THB", "MYR"];

export default function CurrencyConverter() {
  const [amount, setAmount] = useState(100);
  const [from, setFrom] = useState("USD");
  const [to, setTo] = useState("INR");
  const [result, setResult] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setErr(false); setResult(null);
    if (from === to) { setResult(Number(amount)); return; }
    const t = setTimeout(() => {
      api.get("/fx", { params: { base: from, target: to, amount: amount || 0 } })
        .then((r) => setResult(r.data.result))
        .catch(() => setErr(true));
    }, 250);
    return () => clearTimeout(t);
  }, [amount, from, to]);

  const swap = () => { setFrom(to); setTo(from); };
  const fmt = (n, cur) => new Intl.NumberFormat("en-US", { style: "currency", currency: cur, maximumFractionDigits: 2 }).format(n);

  return (
    <div className="border border-zinc-300 bg-white p-5" data-testid="currency-converter">
      <h3 className="font-heading font-900 text-emerald-600 text-lg flex items-center gap-2 mb-4"><DollarSign className="w-5 h-5" /> Currency Converter</h3>
      <div className="flex items-center gap-2">
        <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} data-testid="fx-amount"
          className="w-24 border border-zinc-300 px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-primary" />
        <select value={from} onChange={(e) => setFrom(e.target.value)} data-testid="fx-from" className="border border-zinc-300 px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-primary">
          {CURRENCIES.map((c) => <option key={c}>{c}</option>)}
        </select>
        <button onClick={swap} data-testid="fx-swap" className="p-2 border border-zinc-300 hover:border-primary"><ArrowRightLeft className="w-4 h-4" /></button>
        <select value={to} onChange={(e) => setTo(e.target.value)} data-testid="fx-to" className="border border-zinc-300 px-2 py-2 text-sm outline-none focus:ring-2 focus:ring-primary">
          {CURRENCIES.map((c) => <option key={c}>{c}</option>)}
        </select>
      </div>
      <div className="mt-4 text-lg font-heading font-900" data-testid="fx-result">
        {err ? <span className="text-sm text-destructive">Rates unavailable</span>
          : result == null ? <span className="text-sm text-muted-foreground">Converting…</span>
            : <>{fmt(Number(amount) || 0, from)} = <span className="text-primary">{fmt(result, to)}</span></>}
      </div>
      <div className="text-xs text-muted-foreground mt-1">Live mid-market rates · frankfurter.app (ECB)</div>
    </div>
  );
}
